<template>
    <span>{{ params.value|json2str }}</span>
    <!-- <span>{{ JSON.stringify(params.value) }}</span> -->
</template>

<script>
// import moduleDevice from '@/store/device/moduleDevice.js'
    export default {
      name: 'CellRendererPayload',
      data() {
        return {
          // options: moduleDevice.deviceTypeList,
        }
      },
      filters: {
        json2str: function (value) {
          let str = '';
          for(var index in value) { 
            if (value.hasOwnProperty(index)) {
                str += index + ':' + value[index] + '  ';
            }
          }
          return str
        },
      }
    }
</script>

<style lang="scss" scpoped>
.ag-grid-cell-chip {
  &.vs-chip-success {
    background: rgba(var(--vs-success),.15);
    color: rgba(var(--vs-success),1) !important;
    font-weight: 500;
  }
  &.vs-chip-warning {
    background: rgba(var(--vs-warning),.15);
    color: rgba(var(--vs-warning),1) !important;
    font-weight: 500;
  }
  &.vs-chip-danger {
    background: rgba(var(--vs-danger),.15);
    color: rgba(var(--vs-danger),1) !important;
    font-weight: 500;
  }
}
</style>
